import React from 'react';
import PropTypes from 'prop-types';
import Years from './Years';
import Ages from './Ages';
import LineSegment from './LineSegment';
import TimeMarker from './TimeMarker';
import ActivityMarkers from './ActivityMarkers';

class LineTypeMemory {
  // used to store the current state of the line while creating its segments
  constructor(bornCaptive) {
    // set the initial state
    this.logbookOn = false;
    this.captivityOn = bornCaptive;
  }

  updateType(point) {
    // if event given, update the line state based on event type
    if (point && point.type) {
      if (point.type === 'logbook_start') this.logbookOn = true;
      if (point.type === 'logbook_end') this.logbookOn = false;
      if (point.type === 'capture') this.captivityOn = true;
    }

    // return current state
    return this.logbookOn ? 'logbook' : this.captivityOn ? 'captive' : 'wild';
  }
}


export class Line extends React.Component {
  createLineSegments() {
    const {
      events, elephant, onDateSelected, yearWidth,
    } = this.props;
    const typeMemory = new LineTypeMemory(elephant.cw !== 'wild');

    const linePointEvents = events.filter((event, i) => {
      const nextEvent = i + 1 === events.length ? null : events[i + 1];
      const changesLine = [
        'birth', 'capture', 'logbook_start', 'logbook_end',
        'death', 'estimated_death', 'today',
      ].indexOf(event.type) !== -1;
      const effectsFading = event.fadeAmount !== undefined
        || (nextEvent && nextEvent.fadeAmount !== undefined);
      return changesLine || effectsFading;
    });
    const lineSegments = [];

    // Create segments between events
    for (let i = 0; i < linePointEvents.length - 1; i += 1) {
      const point = linePointEvents[i];
      const nextPoint = linePointEvents[i + 1];
      const lineType = typeMemory.updateType(point);
      lineSegments.push(
        <LineSegment
          yearWidth={yearWidth}
          key={`event${point.key}`}
          lineType={lineType}
          start={point.date}
          end={nextPoint.date}
          fade={[point.fadeAmount, nextPoint.fadeAmount]}
          onDateSelected={onDateSelected}
        />,
      );
    }

    return lineSegments;
  }


  render() {
    const {
      events, focusedDate, elephant, yearWidth,
    } = this.props;

    const start = events[0].date;
    const end = events[events.length - 1].date;

    if (end.isBefore(start)) throw new Error('End cannot be before start');

    // calculate the amount to shift the year labels
    // (time from lifeline start to the beginning of that year)
    const marginBefore = start.diff(start.clone().month(0).date(0), 'days') / 365 * yearWidth;

    // Calculate the focused position based on focusedDate
    const focusedPosition = focusedDate
      ? focusedDate.diff(start, 'days') / 365 * yearWidth
      : null;

    return (
      <div style={{
        flexShrink: '0', display: 'block', position: 'relative',
      }}
      >
        <div style={{ display: 'flex' }}>
          {this.createLineSegments()}
        </div>
        <Years
          startYear={start.year()}
          endYear={end.year()}
          startShift={-marginBefore}
          yearWidth={yearWidth}
        />
        <ActivityMarkers
          start={start}
          elephantId={elephant.pk}
          focusedDate={focusedDate}
          yearWidth={yearWidth}
        />
        <Ages yearCount={end.year() - start.year()} yearWidth={yearWidth} />
        {focusedPosition !== null && <TimeMarker x={focusedPosition} />}
      </div>
    );
  }
}


Line.propTypes = {
  yearWidth: PropTypes.number.isRequired,
  events: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.shape(),
      type: PropTypes.string,
      fadeAmount: PropTypes.number,
    }),
  ),
  focusedDate: PropTypes.shape(),
  onDateSelected: PropTypes.func,
  elephant: PropTypes.shape().isRequired,
};

Line.defaultProps = {
  events: [],
  focusedDate: null,
  onDateSelected: () => {},
};

export default Line;



// WEBPACK FOOTER //
// ./src/components/lifeline/Line/Line.jsx